import type { IsolatedCircuitId } from "./types";

/**
 * The one run the plan is narrowed to, or null when it is showing the sheet.
 *
 * Hover previews a circuit; click locks it. Both isolate to that circuit.
 * Karl's route sits under both: he is asking about that run, so it stays
 * isolated until he answers, but the estimator can still hover another.
 *
 * Its own function because TWO things read it now — which paths are drawn, and
 * whether the cables are drawn at all. Isolating to one run must beat the
 * "draw every cable" switch, and a second copy of this precedence is a second
 * chance for the drawing to disagree with itself.
 */
export const isolatedCircuitId: IsolatedCircuitId = ({
  geometry,
  hoveredCircuitId,
  routeUnderReview,
  selectedCircuitId,
}) => {
  if (!geometry) return null;
  const active = hoveredCircuitId ?? routeUnderReview ?? selectedCircuitId;
  return active && geometry.byCircuit[active] ? active : null;
};
